<template>
  <a :href="source" target="_blank" class="message__document">
    <slot />

    <CPreviewDocument :url="source">
      <div class="document__icon">
        <WIcon icon="icPaper" size="large" />
        Documento
      </div>
    </CPreviewDocument>
  </a>
</template>

<script>
import { WIcon } from '@alice-health/wonderland-vue'

import CPreviewDocument from './CPreviewDocument.vue'

export default {
  components: { WIcon, CPreviewDocument },
  props: {
    source: { type: String, default: undefined }
  }
}
</script>

<style lang="scss">
.message__document {
  max-width: max-content;
  margin: auto;
  display: flex;

  .document__icon {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .message__sender--member & {
    color: var(--gl-color-shades-white);
    fill: var(--gl-color-shades-white);
  }
}
</style>
